import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Button, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
const {Form, FormActions, FormBody} = form;
import {reduxForm} from "redux-form";
import KontaktniUdajePanel from "../components/KontaktniUdajePanel";
import ZpusobDodaniPanel from "../components/ZpusobDodaniPanel";
import {redirectToOrderStep} from "../utils/utils";
import * as steps from "../const/routes";
import RadioField from "./fields/RadioField";
import NahraneSouboryPanel from "../components/NahraneSouboryPanel";
import CustomCheckboxField from "../components/CustomCheckboxField";
import './PlatbaForm.scss';
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář procesu objednávky - Platba.
 */
class PlatbaForm extends Component<WithTranslation> {

    static formName = 'PlatbaForm';

    static propTypes = {
        zpusobyPlatbyList: PropTypes.array.isRequired, // seznam způsobů platby
        zpusobDoprava: PropTypes.object.isRequired, // zvolený způsob dopravy
        pobocka: PropTypes.object, // VO pobočky, pokud je objednávka na pobočku
        adresa: PropTypes.object, // VO adresy, pokud je objednávka na adresu
        zakazkaData: PropTypes.object.isRequired, // data kroku Zakázka
        zakaznikData: PropTypes.object.isRequired, // data kroku Zákazník
        dopravaData: PropTypes.object.isRequired, // data kroku Doprava
        cenovaNabidka: PropTypes.bool, // zda zobrazit checkbox pro cenovou nabídku
        terminDoprava: PropTypes.object, // VO termínu dopravy, pokud je objednávka na adresu
    };

    render() {
        const {onClose, handleSubmit, submitting, error, zpusobyPlatbyList, pobocka, adresa,
            zakazkaData, zakaznikData, dopravaData, cenovaNabidka, terminDoprava, t} = this.props;

        const fileMetas = zakazkaData && zakazkaData.fileMetas || [];

        return <Form onSubmit={handleSubmit} horizontal className={"platba-form"}>
            <FormBody>
                <Row>
                    <Col xs={12} md={8}>
                        <Card className="h-100">
                            <CardHeader>
                                <h2>{t('order.choose_payment_method')}</h2>
                            </CardHeader>
                            <CardBody>
                                {zpusobyPlatbyList.map(zpusobPlatba =>
                                    <RadioField
                                        key={zpusobPlatba.id}
                                        name="zpusobPlatbaId"
                                        label={zpusobPlatba.nazevZpusobPlatba}
                                        value={zpusobPlatba.id}
                                    />
                                )}
                                {/*Stejný problém jako v DopravaForm*/}
                                {/*<ff.ListSelect*/}
                                    {/*name="zpusobPlatba"*/}
                                    {/*label={false}*/}
                                    {/*items={zpusobyPlatbyList}*/}
                                    {/*renderItem={i => i.nazevZpusobPlatba}*/}
                                {/*/>*/}
                                {cenovaNabidka && <CustomCheckboxField
                                    className="left-aligned-checkbox"
                                    name="cenovaNabidka"
                                    label={t('send_price_offer_first')}
                                />}
                                {error && <p className="text-danger">{error}</p>}
                            </CardBody>
                        </Card>
                    </Col>
                    <Col xs={12} md={4}>
                        <NahraneSouboryPanel soubory={fileMetas.map(meta => meta.podslozky + meta.name)}/>
                        <KontaktniUdajePanel kontaktniUdaje={zakaznikData}/>
                        <ZpusobDodaniPanel
                            adresa={adresa}
                            pobocka={pobocka}
                            datum={pobocka ? dopravaData.datumVyzvednuti : dopravaData.datumDoruceni}
                            casVyzvednuti={dopravaData.casVyzvednuti}
                            terminDoprava={terminDoprava}
                        />
                    </Col>
                    <Col xs={12} className="submit-button-panel">
                        <Button color="secondary" type="button" onClick={redirectToOrderStep.bind(this, steps.DOPRAVA, this.props)}>{t('buttons.back')}</Button>
                        <Button color="primary">{t('order.next_step')}</Button>
                    </Col>
                </Row>
            </FormBody>
            <FormActions onClose={onClose} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(withRouter(connect()(reduxForm({
    form: PlatbaForm.formName,
})(PlatbaForm))));
